export const parseOptionalFloat = (value: string): number | undefined => {
  const parsed = Number.parseFloat(value);
  if (Number.isNaN(parsed)) return undefined;

  return parsed;
}

export const parseOptionalInt = (value: string): number | undefined => {
  const parsed = Number.parseInt(value);
  if (Number.isNaN(parsed)) return undefined;

  return parsed;
}
